import { globalAddTranslations } from '~/translations'

import en from './en.yaml'
import zh from './zh.yaml'

export const BENCHMARK_REPORT_NS = 'benchmarkReport'
const translations = { zh, en }

globalAddTranslations(translations, BENCHMARK_REPORT_NS)
